import { Payment } from '../core/state/order/order.model';
import { Subscription } from '../core/state/subscription/subscription.model';

export enum InvoiceStatus {
  PAID = 'PAID',
  PARTIALY_PAID = 'PARTIALY_PAID',
  DRAFT = 'DRAFT',
  PROCESSING = 'PROCESSING',
  SENT = 'SENT',
  OVERDUE = 'OVERDUE',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
}

export interface TenantBankAccount {
  bankName: string;
  accountName: string;
  accountNumber: string;
  branchName: string;
  swiftCode?: string;
}

export interface PublicTenantPaymentConfig {
  acceptedMethods: string[];
  bankAccounts: TenantBankAccount[];
  payhereMerchantId?: string;
  stripePublishableKey?: string;
  sandbox?: boolean;
  isSystemManaged?: boolean;
  isConfigured?: boolean;
}

export interface Invoice {
  _id: string;
  invoiceNumber: string;
  createdOn: Date;
  dueDate: Date;
  amount: number;
  currency: string;
  status: InvoiceStatus;
  subscription: Subscription;
  payments: Payment[];
  paymentConfig?: PublicTenantPaymentConfig;
}

